"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _KYCConfirmMitekModalComponent = _interopRequireDefault(require("./KYCConfirmMitekModalComponent"));
var _APIFrame = _interopRequireDefault(require("../../common/APIFrame/APIFrame"));
var _Spinner = _interopRequireDefault(require("../../common/Spinner/Spinner"));
var _path = _interopRequireDefault(require("../../../helpers/path"));
var _kycConfigShapePropTypes = require("../../../propTypes/kycConfigShapePropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var KYCMitekComponent = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function KYCMitekComponent(props) {
    var _this;
    _classCallCheck(this, KYCMitekComponent);
    _this = _callSuper(this, KYCMitekComponent, [props]);
    _defineProperty(_this, "confirmInfoMitek", function () {
      var _this$props = _this.props,
        alphaPointUserID = _this$props.alphaPointUserID,
        userName = _this$props.userName,
        confirmInfoMitek = _this$props.confirmInfoMitek;
      var confirmInfoMitekPayload = {
        UserId: Number(alphaPointUserID),
        UserName: userName
      };
      confirmInfoMitek(confirmInfoMitekPayload);
    });
    _defineProperty(_this, "openModal", function (isOpen) {
      return _this.setState({
        isOpen: isOpen
      });
    });
    _this.state = {
      isOpen: false
    };
    return _this;
  }
  _inherits(KYCMitekComponent, _React$Component);
  return _createClass(KYCMitekComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        alphaPointUserID = _this$props2.alphaPointUserID,
        alphaPointSessiontoken = _this$props2.alphaPointSessiontoken,
        _this$props2$kycConfi = _this$props2.kycConfig,
        type = _this$props2$kycConfi.type,
        requestIdentifier = _this$props2$kycConfi.requestIdentifier,
        launchMitek = _this$props2.launchMitek,
        userConfig = _this$props2.userConfig;
      var config = userConfig.reduce(function (item, i) {
        item[i.Key] = i.Value;
        return item;
      }, {});
      var userInfo = {
        firstName: config.fname,
        middleName: config.middleName,
        lastName: config.lname,
        dob: config.dob,
        email: config.email,
        billingStreetAddress: config.billingStreetAddress,
        billingCountry: config.billingCountry,
        billingCity: config.billingCity,
        billingState: config.billingState,
        billingZip: config.billingZip,
        phone: config.telephone,
        state: config.billingState,
        billingStreetNumber: config.billingStreetNumber,
        billingStreetType: config.billingStreetType,
        billingSuburb: config.billingCity,
        accountName: alphaPointUserID,
        billingFlatNumber: '',
        salutation: ''
      };
      var clientInfo = {
        alphaPointSessiontoken: alphaPointSessiontoken,
        alphaPointUserID: alphaPointUserID,
        validationStage: 2,
        validator: type
      };
      launchMitek({
        requestIdentifier: requestIdentifier,
        clientInfo: clientInfo,
        userInfo: userInfo
      }, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        kyc = _this$props3.kyc,
        processing = _this$props3.processing;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
        isVisible: processing
      }), !processing && /*#__PURE__*/_react["default"].createElement(_APIFrame["default"], {
        id: "mitek-iframe",
        src: (0, _path["default"])("/mitek.html".concat(kyc.urlParams)),
        customClass: "mitek",
        onLoad: function onLoad() {
          var iframe = document.getElementById('mitek-iframe');
          var that = _this2;
          iframe.contentWindow.document.addEventListener('idchecker-finish', function () {
            iframe.contentWindow.document.querySelector('[ng-show="vm.success"]').innerHTML = ' ';
            that.openModal(true);
          }, false);
        }
      }), /*#__PURE__*/_react["default"].createElement(_KYCConfirmMitekModalComponent["default"], {
        isOpen: this.state.isOpen,
        close: function close() {
          return _this2.confirmInfoMitek();
        },
        onConfirm: function onConfirm() {
          return _this2.confirmInfoMitek();
        }
      }));
    }
  }]);
}(_react["default"].Component);
KYCMitekComponent.propTypes = {
  kycConfig: _propTypes["default"].shape({
    type: _propTypes["default"].string,
    levels: _propTypes["default"].arrayOf(_propTypes["default"].shape(_kycConfigShapePropTypes.kycConfigLevelShape))
  })
};